import React from 'react';
import { Row, Col, Card, Typography } from 'antd';
import {
  ApartmentOutlined,
  AuditOutlined,
  BarChartOutlined,
  CalendarOutlined,
  // SettingOutlined,
  ScheduleOutlined
  // SunOutlined
} from '@ant-design/icons';
import { getLoggedInUser } from 'utilities/helpers';
import styles from '../../index.module.less';
import { history } from '@/app/history';
import { MANAGER, EMPLOYEE, EXECUTIVE } from 'utilities/roleRights';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faUsersLine } from '@fortawesome/free-solid-svg-icons';

const { Title, Text } = Typography;

const ActionCards = () => {
  const user = getLoggedInUser();
  // const cards =
  //   // user?.user_details?.role_id === MANAGER
  //   [MANAGER, EXECUTIVE].includes(user?.user_details?.role_id)
  //     ? [
  //         {
  //           name: 'Plan',
  //           description: 'Organize tasks and schedule activities',
  //           icon: <CalendarOutlined className={styles.calendarIcon} />,
  //           background: styles.blueBg,
  //           url: 'tasks'
  //         },
  //         {
  //           name: 'Review',
  //           description: 'Check progress and analyze performance',
  //           icon: <AuditOutlined className={styles.chartIcon} />,
  //           background: styles.purpleBg,
  //           url: 'all-tasks'
  //         },
  //         {
  //           name: 'Work',
  //           description: `View today's tasks and priorities`,
  //           icon: <ScheduleOutlined className={styles.settingsIcon} />,
  //           background: styles.greenBg,
  //           url: 'my-tasks'
  //         },
  //         {
  //           name: 'Follow-up',
  //           description: `Manage team and individual follow-ups`,
  //           icon: (
  //             <FontAwesomeIcon
  //               icon={faUsersLine}
  //               className="!bg-orange-100 !text-orange-600 !text-2xl"
  //             />
  //           ),
  //           background: styles.orangeBg,
  //           url: 'follow-up'
  //         },
  //         {
  //           name: 'Configure',
  //           description: `Manage clients, projects and users`,
  //           icon: (
  //             <FontAwesomeIcon
  //               icon={faGear}
  //               className="!bg-indigo-100 !text-indigo-600 !text-2xl"
  //             />
  //           ),
  //           background: styles.indigoBg,
  //           url: 'configure'
  //         },
  //         {
  //           name: 'Staffing',
  //           description: `Plan and manage staffing`,
  //           icon: <ApartmentOutlined className={styles.staffingIcon} />,
  //           background: styles.brownBg,
  //           url: 'plan-staffing'
  //         }
  //       ]
  //     : [
  //         {
  //           name: 'Review',
  //           description: 'Check progress and analyze performance',
  //           icon: <AuditOutlined className={styles.chartIcon} />,
  //           background: styles.purpleBg,
  //           url: 'all-tasks'
  //         },
  //         {
  //           name: 'Work',
  //           description: `View today's tasks and priorities`,
  //           icon: <ScheduleOutlined className={styles.settingsIcon} />,
  //           background: styles.greenBg,
  //           url: 'my-tasks'
  //         }
  //       ];

  const managerTiles = [
    {
      name: 'Plan',
      description: 'Organize tasks and schedule activities',
      icon: <CalendarOutlined className={styles.calendarIcon} />,
      background: styles.blueBg,
      url: 'tasks'
    },
    {
      name: 'Review',
      description: 'Check progress and analyze performance',
      icon: <AuditOutlined className={styles.chartIcon} />,
      background: styles.purpleBg,
      url: 'all-tasks'
    },
    {
      name: 'Work',
      description: `View today's tasks and priorities`,
      icon: <ScheduleOutlined className={styles.settingsIcon} />,
      background: styles.greenBg,
      url: 'my-tasks'
    },
    {
      name: 'Follow-up',
      description: `Manage team and individual follow-ups`,
      icon: (
        <FontAwesomeIcon
          icon={faUsersLine}
          className="!bg-orange-100 !text-orange-600 !text-2xl"
        />
      ),
      background: styles.orangeBg,
      url: 'follow-up'
    },
    {
      name: 'Configure',
      description: `Manage clients, projects and users`,
      icon: (
        <FontAwesomeIcon
          icon={faGear}
          className="!bg-indigo-100 !text-indigo-600 !text-2xl"
        />
      ),
      background: styles.indigoBg,
      url: 'configure'
    },
    {
      name: 'Staffing',
      description: `View team utilization and manage staffing`,
      icon: <ApartmentOutlined className={styles.staffingIcon} />,
      background: styles.brownBg,
      url: 'plan-staffing'
    }
  ];

  const weeklyLitTile = {
    name: 'Weekly Insights',
    description: 'View and manage weekly insights',
    icon: <BarChartOutlined className={styles.weekIcon} />,
    background: styles.charcoal,
    url: 'weekly-list'
  };

  const roleId = user?.user_details?.role_id;

  let cards = [];

  if (roleId === EXECUTIVE) {
    cards = [...managerTiles, weeklyLitTile];
  } else if (roleId === MANAGER) {
    cards = managerTiles;
  } else {
    cards = [
      {
        name: 'Review',
        description: 'Check progress and analyze performance',
        icon: <AuditOutlined className={styles.chartIcon} />,
        background: styles.purpleBg,
        url: 'all-tasks'
      },
      {
        name: 'Work',
        description: `View today's tasks and priorities`,
        icon: <ScheduleOutlined className={styles.settingsIcon} />,
        background: styles.greenBg,
        url: 'my-tasks'
      }
    ];
  }

  return (
    <section className={styles.cardsSection}>
      <div className="gap-4 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 !pb-6">
        {cards?.map((item, index) => {
          return (
            <div
              key={index}
              className={
                'flex flex-col justify-between h-full items-center p-8 transition-all duration-300 bg-white rounded-lg cursor-pointer hover:shadow-xl shadow-bottom'
              }
              bordered={false}
              onClick={() => history.push(`${item.url}`)}
            >
              <div className={`${styles.iconWrapper} ${item.background}`}>
                {item?.icon}
              </div>
              <Title level={4} className={styles.cardTitle}>
                {item?.name}
              </Title>
              <Text className={`text-center ${styles.cardDescription}`}>
                {item?.description}
              </Text>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ActionCards;
